import { Input } from '@angular/core';
export class TmAccountRequest {
    IsGuest: boolean;
    IsPhoneCustomer: boolean;
    Email: string;
    Subscribe: boolean;
    Phone: string;
    Password: string;
    RetypedPassword: string;
    CustomerNumber: string;
    FirstName: string;
    LastName: string;
    Address1: string;
    Address2: string;
    IsPOBox: boolean;
    POBox: string;
    City: string;
    Province: string;
    PostalCode: string;
    ReCaptchaToken: string;
}

export class TmEmailAddressRequest {
    Email: string;
}

export class TmPasswordResetRequest {
    Email: string;
    CheckSecurityQuestion: boolean;
    BaseUrl: string;
}

export class TmPasswordInfoRequest {
    Info: string;
}

export class TmPasswordVerifyRequest {
    Email: string;
    PhoneNumber: string;
    PostalCode: string;
    SecurityQuestionId: number;
    SecurityQuestionAnswer: string;
    HasSecurityQuestion: boolean;
}

export class TmUpdatePasswordRequest {
    NewPassword: string;
    NewPasswordConfirmed: string;
    Info: string;
}

export class TmCustomerSecurityQuestionAnswerRequest {
    constructor(
        public QuestionId: number,
        public Answer: string,
    ) {}
}



// WEBPACK FOOTER //
// C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/ngc-webpack??ref--0-1!C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/angular2-template-loader!../tscapi/model/request/account-request.ts